export default "__VITE_ASSET__a21a69f2__"